import { TieredMenu } from "primereact/tieredmenu";
import { IconDispatcher } from "shared/Icons";
import '../editor.scss';

const backgroundColor = [
    { label: "White", value: "#ffffff" },
    { label: "Grey-100", value: "#D7DAE0" },
    { label: "Blue-100", value: "#C9DAFF" },
    { label: "Cyan-100", value: "#ADEBF3" },
    { label: "Green-100", value: "#AEF2CF" },
    { label: "Yellow-100", value: "#FDF4C4" },
    { label: "Orange-100", value: "#FADAB0" },
    { label: "Red-100", value: "#FACCC6" },
    { label: "Pink-100", value: "#F9C8EA" },
    { label: "Purple-100", value: "#DBD1FD" },
];
const TextColors = [
    { label: "Primary-Text", value: "#262626" },
    { label: "Grey-600", value: "#57647B" },
    { label: "Blue-600", value: "#2741ca" },
    { label: "Cyan-700", value: "#3B9AB1" },
    { label: "Green-700", value: "#318b59" },
    { label: "Yellow-700", value: "#B89F14" },
    { label: "Orange-700", value: "#CD6513" },
    { label: "Red-600", value: "#D83835" },
    { label: "Pink-600", value: "#cc4190" },
    { label: "Purple-600", value: "#5E47B9" },
    { label: "White", value: "#ffffff" },

];
export const ColorsOptions = ({ editor, colorRef, handleshow }) => {

    if (!editor) {
        return null
    }

    const handleHeadingChange = (color, command, e) => {
         e && e.preventDefault()
        if (command === 'setColor') {
            editor.chain().focus().setColor(color).run();
            handleshow(e, 'color')

            return;
        }
        editor.commands[command]({ color: color });
        handleshow(e, 'color')
    };

    const items = [
        {
            label: "Background",
            items: backgroundColor.map(color => {
                return {
                    template: <div
                    className='hover-color text-center'
                    onClick={(e) => handleHeadingChange(color.value, "setHighlight", e)}
                    style={{ background: color.value ,width:'30px',height:'30px',
                         border: color.value === '#ffffff' ? '1px solid #c4c4c4' : 'none'}}>{""}</div>
                }
            })
        },
        {
            label: "Text",
            items: TextColors.map(color => {
                return {
                    template: <div className='hover-color text-center' onClick={(e) => handleHeadingChange(color.value, "setColor", e)}   style={{ background: color.value ,width:'30px',height:'30px',
                        border: color.value === '#ffffff' ? '1px solid #c4c4c4' : 'none'}}>{""}</div>
                }
            })
        }
    ];


    return (
        <>
            <TieredMenu model={items} popup ref={colorRef} breakpoint="767px" className='menu-color-toolbar ' />
            <button
                title='Color'
                className={editor.isActive('highlight') || editor.isActive('textStyle') ? 'is-active' : ''}
                onClick={(e) => {
                    e.preventDefault()
                    handleshow(e, 'color')
                }}
            >
                {IconDispatcher('highlighter')}
            </button>
        </>
    );
}